export const LICENSES_MAP_ERRORS = {
  alabama: {
    occupationalTherapist: {
      regex: '^OT\\d+$',
      error: 'Begin with OT and no space (Ex: OT123456)',
      errorArray: ['Must Begin with "OT"', 'No spaces', 'Ex: OT123456'],
    },
    occupationalTherapyAssistant: {
      regex: '^OTA\\d+$',
      error: 'Begin with OTA and no space (Ex: OTA123456)',
      errorArray: ['Must Begin with "OTA"', 'No spaces', 'Ex: OTA123456'],
    },
    dentist: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    dentalHygienist: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  alaska: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  arizona: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    athleticTrainer: {
      regex: '^ATR-\\d+$',
      error: 'Begin with ATR and no space (Ex: ATR-123456)',
      errorArray: ['Must Begin with "ATR-"', 'No spaces', 'Ex: ATR-123456'],
    },
    occupationalTherapyAssistant: {
      regex: '^OTA-\\d+$',
      error: 'Begin with OTA and no space (Ex: OTA-123456)',
      errorArray: ['Must Begin with "OTA-"', 'No spaces', 'Ex: OTA-123456'],
    },
    occupationalTherapist: {
      regex: '^OTH-\\d+$',
      error: 'Begin with OTH and no space (Ex: OTH-A123456)',
      errorArray: ['Must Begin with "OTH-"', 'No spaces', 'Ex: OTH-123456'],
    },
  },

  arkansas: {
    registeredNurse: {
      regex: '^R\\d+$',
      error: 'Begin with R and no space (Ex: R99999999)',
      errorArray: ['Must Begin with "R"', 'No spaces', 'Ex: R99999999'],
    },
    registeredNursePractitioner: {
      regex: '^P\\d+$',
      error: 'Begin with P and no space (Ex: P99999999)',
      errorArray: ['Must Begin with "P"', 'No spaces', 'Ex: P99999999'],
    },
    licensedPracticalNurse: {
      regex: '^L\\d+$',
      error: 'Begin with L and no space (Ex: L99999999)',
      errorArray: ['Must Begin with "L"', 'No spaces', 'Ex: L99999999'],
    },
    licensedPsychiatricTechnicianNurse: {
      regex: '^T\\d+$',
      error: 'Begin with T and no space (Ex: T99999999)',
      errorArray: ['Must Begin with "T"', 'No spaces', 'Ex: T99999999'],
    },
    certifiedRegisteredNurseAnesthetist: {
      regex: '^C\\d+$',
      error: 'Begin with C and no space (Ex: C99999999)',
      errorArray: ['Must Begin with "C"', 'No spaces', 'Ex: C99999999'],
    },
    certifiedNurseMidwife: {
      regex: '^M\\d+$',
      error: 'Begin with M and no space (Ex: M99999999)',
      errorArray: ['Must Begin with "M"', 'No spaces', 'Ex: M99999999'],
    },
    clinicalNurseSpecialist: {
      regex: '^S\\d+$',
      error: 'Begin with S and no space (Ex: S99999999)',
      errorArray: ['Must Begin with "S"', 'No spaces', 'Ex: S99999999'],
    },
    certifiedNursePractioner: {
      regex: '^A\\d+$',
      error: 'Begin with A and no space (Ex: A99999999)',
      errorArray: ['Must Begin with "A"', 'No spaces', 'Ex: A99999999'],
    },
  },
  california: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  colorado: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  connecticut: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  delaware: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  districtOfColumbia: {
    registeredNurse: {
      regex: '^RN\\d+$',
      error: 'Begin with RN and no space (Ex: RN99999999)',
      errorArray: ['Must Begin with "RN"', 'No spaces', 'Ex: RN99999999'],
    },
    licensedPracticalNurse: {
      regex: '^LPN\\d+$',
      error: 'Begin with LPN and no space (Ex: LPN99999999)',
      errorArray: ['Must Begin with "LPN"', 'No spaces', 'Ex: LPN99999999'],
    },
    homeHealthAids: {
      regex: '^HHA\\d+$',
      error: 'Begin with HHA and no space (Ex: HHA11111)',
      errorArray: ['Must Begin with "HHA"', 'No spaces', 'Ex: HHA11111'],
    },
  },
  florida: {
    acupuncturist: {
      regex: '^AP\\d+$',
      error: 'Begin with AP and no space (Ex: AP123456)',
      errorArray: ['Must Begin with "AP"', 'No spaces', 'Ex: AP123456'],
    },
    registeredNurse: {
      regex: '^RN\\d+$',
      error: 'Begin with RN and no space (Ex: RN123456)',
      errorArray: ['Must Begin with "RN"', 'No spaces', 'Ex: RN123456'],
    },
    optometry: {
      regex: '^OP\\d+$',
      error: 'Begin with OP and no space (Ex: OP123456)',
      errorArray: ['Must Begin with "OP"', 'No spaces', 'Ex: OP123456'],
    },
    physicalTherapist: {
      regex: '^PT\\d+$',
      error: 'Begin with PT and no space (Ex: PT123456)',
      errorArray: ['Must Begin with "PT"', 'No spaces', 'Ex: PT123456'],
    },
    physicalTherapyAssistant: {
      regex: '^PTA\\d+$',
      error: 'Begin with PTA and no space (Ex: PTA123456)',
      errorArray: ['Must Begin with "PTA"', 'No spaces', 'Ex: PTA123456'],
    },
    physicianAssistant: {
      regex: '',
      error: 'Begin with PT and no space (Ex: PT123456)',
      errorArray: ['Must Begin with "PT"', 'No spaces', 'Ex: PT123456'],
    },

    podiatrist: {
      regex: '^POD\\d+$',
      error: 'Begin with POD and no space (Ex: POD123456)',
      errorArray: ['Must Begin with "POD"', 'No spaces', 'Ex: POD123456'],
    },
    psychologist: {
      regex: '^PY\\d+$',
      error: 'Begin with PY and no space (Ex: PY123456)',
      errorArray: ['Must Begin with "PY"', 'No spaces', 'Ex: PY123456'],
    },
    paramedic: {
      regex: '^PMD\\d+$',
      error: 'Begin with PMD and no space (Ex: PMD123456)',
      errorArray: ['Must Begin with "PMD"', 'No spaces', 'Ex: PMD123456'],
    },
    advancedPracticeRegisteredNurse: {
      regex: '^APRN\\d+$',
      error: 'Begin with APRN and no space (Ex: APRN123456)',
      errorArray: ['Must Begin with "APRN"', 'No spaces', 'Ex: APRN123456'],
    },
    audiologist: {
      regex: '^AY\\d+$',
      error: 'Begin with AY and no space (Ex: AY123456)',
      errorArray: ['Must Begin with "AY"', 'No spaces', 'Ex: AY123456'],
    },
    audiologyAssistant: {
      regex: '^AI\\d+$',
      error: 'Begin with AI and no space (Ex: AI123456)',
      errorArray: ['Must Begin with "(AI)"', 'No spaces', 'Ex: (AI)123456'],
    },
    certifiedNursingAssistant: {
      regex: '^CNA\\d+$',
      error: 'Begin with CNA and no space (Ex: CNA123456)',
      errorArray: ['Must Begin with "CNA"', 'No spaces', 'Ex: CNA123456'],
    },
    certifiedOptometrist: {
      regex: '^OPC\\d+$',
      error: 'Begin with OPC and no space (Ex: OPC123456)',
      errorArray: ['Must Begin with "OPC"', 'No spaces', 'Ex: OPC123456'],
    },
    certifiedRespiratoryTherapist: {
      regex: '^TT\\d+$',
      error: 'Begin with TT and no space (Ex: TT123456)',
      errorArray: ['Must Begin with "TT"', 'No spaces', 'Ex: TT123456'],
    },
    chiropracticPhysician: {
      regex: '^CH\\d+$',
      error: 'Begin with CH and no space (Ex: CH123456)',
      errorArray: ['Must Begin with "CH"', 'No spaces', 'Ex: CH123456'],
    },
    clinicalLaboratoryDirector: {
      regex: '^DI\\d+$',
      error: 'Begin with DI and no space (Ex: DI123456)',
      errorArray: ['Must Begin with "DI"', 'No spaces', 'Ex: DI123456'],
    },
    clinicalLaboratorySupervisor: {
      regex: '^SU\\d+$',
      error: 'Begin with SU and no space (Ex: SU123456)',
      errorArray: ['Must Begin with "SU"', 'No spaces', 'Ex: SU123456'],
    },
    clinicalLaboratoryTechnician: {
      regex: '^TC\\d+$',
      error: 'Begin with TC and no space (Ex: TC123456)',
      errorArray: ['Must Begin with "TC"', 'No spaces', 'Ex: TC123456'],
    },
    clinicalLaboratoryTechnologist: {
      regex: '^TN\\d+$',
      error: 'Begin with TN and no space (Ex: TN123456)',
      errorArray: ['Must Begin with "TN"', 'No spaces', 'Ex: TN123456'],
    },
    clinicalNurseSpecialist: {
      regex: '^CNS\\d+$',
      error: 'Begin with CNS and no space (Ex: CNS123456)',
      errorArray: ['Must Begin with "CNS"', 'No spaces', 'Ex: CNS123456'],
    },
    dentalHygienist: {
      regex: '^DH\\d+$',
      error: 'Begin with DH and no space (Ex: DH123456)',
      errorArray: ['Must Begin with "DH"', 'No spaces', 'Ex: DH123456'],
    },
    dentalLabs: {
      regex: '^DL\\d+$',
      error: 'Begin with DL and no space (Ex: DL123456)',
      errorArray: ['Must Begin with "DL"', 'No spaces', 'Ex: DL123456'],
    },
    dentist: {
      regex: '^DN\\d+$',
      error: 'Begin with DN and no space (Ex: DN123456)',
      errorArray: ['Must Begin with "DN"', 'No spaces', 'Ex: DN123456'],
    },
    diagnosticRadiologicalPhysicist: {
      regex: '^DRP\\d+$',
      error: 'Begin with DRP and no space (Ex: DRP123456)',
      errorArray: ['Must Begin with "DRP"', 'No spaces', 'Ex: DRP123456'],
    },
    dietician: {
      regex: '^ND\\d+$',
      error: 'Begin with ND and no space (Ex: ND123456)',
      errorArray: ['Must Begin with "ND"', 'No spaces', 'Ex: ND123456'],
    },
    electrologist: {
      regex: '^EO\\d+$',
      error: 'Begin with EO and no space (Ex: EO123456)',
      errorArray: ['Must Begin with "EO"', 'No spaces', 'Ex: EO123456'],
    },
    emergencyMedicalTechnician: {
      regex: '^EMT\\d+$',
      error: 'Begin with EMT and no space (Ex: EMT123456)',
      errorArray: ['Must Begin with "EMT"', 'No spaces', 'Ex: EMT123456'],
    },
    healthAccessDentist: {
      regex: '^HAD\\d+$',
      error: 'Begin with HAD and no space (Ex: HAD123456)',
      errorArray: ['Must Begin with "HAD"', 'No spaces', 'Ex: HAD123456'],
    },
    hearingAidSpecialist: {
      regex: '^AS\\d+$',
      error: 'Begin with AS and no space (Ex: AS123456)',
      errorArray: ['Must Begin with "AS"', 'No spaces', 'Ex: AS123456'],
    },
    licensedMarriageAndFamilyTherapist: {
      regex: '^MT\\d+$',
      error: 'Begin with MT and no space (Ex: MT123456)',
      errorArray: ['Must Begin with "MT"', 'No spaces', 'Ex: MT123456'],
    },
    licensedClinicalSocialWorker: {
      regex: '^SW\\d+$',
      error: 'Begin with SW and no space (Ex: SW123456)',
      errorArray: ['Must Begin with "SW"', 'No spaces', 'Ex: SW123456'],
    },
    licensedMentalHealthCounselor: {
      regex: '^MH\\d+$',
      error: 'Begin with MH and no space (Ex: MH123456)',
      errorArray: ['Must Begin with "MH"', 'No spaces', 'Ex: MH123456'],
    },
    licensedPracticalNurse: {
      regex: '^PN\\d+$',
      error: 'Begin with PN and no space (Ex: PN123456)',
      errorArray: ['Must Begin with "PN"', 'No spaces', 'Ex: PN123456'],
    },
    massageTherapist: {
      regex: '^MA\\d+$',
      error: 'Begin with MA and no space (Ex: MA123456)',
      errorArray: ['Must Begin with "MA"', 'No spaces', 'Ex: MA123456'],
    },
    medicalDoctor: {
      regex: '^ME\\d+$',
      error: 'Begin with ME and no space (Ex: ME123456)',
      errorArray: ['Must Begin with "ME"', 'No spaces', 'Ex: ME123456'],
    },
    midwife: {
      regex: '^MW\\d+$',
      error: 'Begin with MW and no space (Ex: MW123456)',
      errorArray: ['Must Begin with "MW"', 'No spaces', 'Ex: MW123456'],
    },
    nursingHomeAdministrator: {
      regex: '^NHA\\d+$',
      error: 'Begin with NHA and no space (Ex: NHA123456)',
      errorArray: ['Must Begin with "NHA"', 'No spaces', 'Ex: NHA123456'],
    },
    nutritionCounselor: {
      regex: '^NC\\d+$',
      error: 'Begin with NC and no space (Ex: NC123456)',
      errorArray: ['Must Begin with "NC"', 'No spaces', 'Ex: NC123456'],
    },
    occupationalTherapist: {
      regex: '^OT\\d+$',
      error: 'Begin with OT and no space (Ex: OT123456)',
      errorArray: ['Must Begin with "OT"', 'No spaces', 'Ex: OT123456'],
    },
    occupationalTherapyAssistant: {
      regex: '^OTA\\d+$',
      error: 'Begin with OTA and no space (Ex: OTA123456)',
      errorArray: ['Must Begin with "OTA"', 'No spaces', 'Ex: OTA123456'],
    },
    pharmacist: {
      regex: '^PS\\d+$',
      error: 'Begin with PS and no space (Ex: PS123456)',
      errorArray: ['Must Begin with "PS"', 'No spaces', 'Ex: PS123456'],
    },
    // physicalTherapist: {
    //   regex: '',
    //   error: '',
    //   errorArray: [],
    // },
    pharmacyTechnician: {
      regex: '^RPT\\d+$',
      error: 'Begin with RPT and no space (Ex: RPT123456)',
      errorArray: ['Must Begin with "RPT"', 'No spaces', 'Ex: RPT123456'],
    },
    registeredRespiratoryTherapist: {
      regex: '^RT\\d+$',
      error: 'Begin with RT and no space (Ex: RT123456)',
      errorArray: ['Must Begin with "RT"', 'No spaces', 'Ex: RT123456'],
    },
    respiratoryCarePractitionerCriticalCare: {
      regex: '^TUC\\d+$',
      error: 'Begin with TUC and no space (Ex: TUC123456)',
      errorArray: ['Must Begin with "TUC"', 'No spaces', 'Ex: TUC123456'],
    },
    respiratoryCarePractitionerNonCriticalCare: {
      regex: '^TUN\\d+$',
      error: 'Begin with TUN and no space (Ex: TUN123456)',
      errorArray: ['Must Begin with "TUN"', 'No spaces', 'Ex: TUN123456'],
    },
    speechLanguagePathologist: {
      regex: '^SA\\d+$',
      error: 'Begin with SA and no space (Ex: SA123456)',
      errorArray: ['Must Begin with "SA"', 'No spaces', 'Ex: SA123456'],
    },
    speechLanguagePathologyAssistant: {
      regex: '^SI\\d+$',
      error: 'Begin with SI and no space (Ex: SI123456)',
      errorArray: ['Must Begin with "SI"', 'No spaces', 'Ex: SI123456'],
    },
  },
  georgia: {
    registeredNurse: {
      regex: '^RN\\d+$',
      error: 'Begin with RN and no space (Ex: RN99999999)',
      errorArray: ['Must Begin with "RN"', 'No spaces', 'Ex: RN99999999'],
    },
    licensedPracticalNurse: {
      regex: '^LPN\\d+$',
      error: 'Begin with LPN and no space (Ex: LPN99999999)',
      errorArray: ['Must Begin with "LPN"', 'No spaces', 'Ex: LPN99999999'],
    },
    massageTherapist: {
      regex: '^MT\\d+$',
      error: 'Begin with MT and no space (Ex: MT88888888)',
      errorArray: ['Must Begin with "MT"', 'No spaces', 'Ex: MT88888888'],
    },
    occupationalTherapist: {
      regex: '^OT\\d+$',
      error: 'Begin with OT and no space (Ex: OT12345)',
      errorArray: ['Must Begin with "OT"', 'No spaces', 'Ex: OT12345'],
    },
    occupationalTherapistAssistant: {
      regex: '^OTA\\d+$',
      error: 'Begin with OTA and no space (Ex: OTA12345)',
      errorArray: ['Must Begin with "OTA"', 'No spaces', 'Ex: OTA12345'],
    },
    nursingHomeAdministrator: {
      regex: '^NHA\\d+$',
      error: 'Begin with NHA and no space (Ex: NHA12345)',
      errorArray: ['Must Begin with "NHA"', 'No spaces', 'Ex: NHA12345'],
    },
    physicalTherapist: {
      regex: '^PT\\d+$',
      error: 'Begin with PT and no space (Ex: PT12345)',
      errorArray: ['Must Begin with "PT"', 'No spaces', 'Ex: PT12345'],
    },
    physicalTherapistAssistant: {
      regex: '^PTA\\d+$',
      error: 'Begin with PTA and no space (Ex: PTA12345)',
      errorArray: ['Must Begin with "PTA"', 'No spaces', 'Ex: PTA12345'],
    },
  },
  hawaii: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  idaho: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    electricalJourneyman: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    masterElectrician: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    plumbingJourneyman: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    plumbingContractor: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  illinois: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  indiana: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  iowa: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  kansas: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  kentucky: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  louisiana: {
    dentalHygienist: {
      regex: '^\\d+$',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    dentist: {
      regex: '^\\d+$',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  maine: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  maryland: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  massachusetts: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  michigan: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    electricalApprentice: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    electricalJourneyman: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    masterElectrician: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  minnesota: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  mississippi: {
    occupationalTherapist: {
      regex: '^OT\\d+$',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with OT', 'No spaces', 'Ex: OT99999999'],
    },
    occupationalTherapyAssistant: {
      regex: '^TA\\d+$',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with TA', 'No spaces', 'Ex: TA99999999'],
    },
    respiratoryCarePractitioner: {
      regex: '^RCP\\d+$',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with RCP', 'No spaces', 'Ex: RCP99999999'],
    },
  },
  missouri: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  montana: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  nebraska: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  nevada: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  newHampshire: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  newJersey: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  newMexico: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    certifiedRegisteredNurseAnesthetist: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    certifiedNursePractioner: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },

    certifiedHemodialysisTechnician: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    certifiedHemodialysisTechnicianII: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    certifiedMedicationAide: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    certifiedNurseSpecialist: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },

    lactationCareProvider: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  newYork: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  northCarolina: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  northDakota: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  ohio: {
    advancedCosmetologist: {
      regex: '^COSA.\\d+$',
      error: 'Begin with COSA. and no space (Ex: COSA.123456)',
      errorArray: ['Must Begin with "COSA."', 'No spaces', 'COSA.123456'],
    },
    cosmetologistInstructor: {
      regex: '^COSI.\\d+$',
      error: 'Begin with COSI. and no space (Ex: COSI.99999999)',
      errorArray: ['Must Begin with "COSI."', 'No spaces', 'COSI.99999999'],
    },
    cosmetologist: {
      regex: '^COS.\\d+$',
      error: 'Begin with COS. and no space (Ex: COS.123456)',
      errorArray: ['Must Begin with "COS."', 'No spaces', 'COS.123456'],
    },
    advancedEsthetician: {
      regex: '^ESTA.\\d+$',
      error: 'Begin with ESTA. and no space (Ex: ESTA.123456)',
      errorArray: ['Must Begin with "ESTA."', 'No spaces', 'ESTA.123456'],
    },
    esthetician: {
      regex: '^EST.\\d+$',
      error: 'Begin with EST. and no space (Ex: EST.123456)',
      errorArray: ['Must Begin with "EST."', 'No spaces', 'EST.123456'],
    },
    estheticianInstructor: {
      regex: '^ESTI.\\d+$',
      error: 'Begin with ESTI. and no space (Ex: ESTI.123456)',
      errorArray: ['Must Begin with "ESTI."', 'No spaces', 'ESTI.123456'],
    },
    advancedHairDesigner: {
      regex: '^HAD\\d+$',
      error: 'Begin with HAD and no space (Ex: HAD123456)',
      errorArray: ['Must Begin with "HAD"', 'No spaces', 'Ex: HAD123456'],
    },
    advancedManicurist: {
      regex: '^MANA.\\d+$',
      error: 'Begin with MANA. and no space (Ex: MANA.123456)',
      errorArray: ['Must Begin with "MANA."', 'No spaces', 'MANA.123456'],
    },
    advancedNaturalHairStylist: {
      regex: '^NHSA.\\d+$',
      error: 'Begin with NHSA. and no space (Ex: NHSA.123456)',
      errorArray: ['Must Begin with "NHSA."', 'No spaces', 'NHSA.123456'],
    },
    manicuristInstructor: {
      regex: '^MANI.\\d+$',
      error: 'Begin with MANI. and no space (Ex: MANI.123456)',
      errorArray: ['Must Begin with "MANI."', 'No spaces', 'MANI.123456'],
    },
    manicurist: {
      regex: '^MAN.\\d+$',
      error: 'Begin with MAN. and no space (Ex: MAN.123456)',
      errorArray: ['Must Begin with "MAN."', 'No spaces', 'MAN.123456'],
    },
    audiologist: {
      regex: '^A.\\d+$',
      error: 'Begin with A. and no space (Ex: A.99999999)',
      errorArray: ['Must Begin with "A."', 'No spaces', 'A.99999999'],
    },
    speechLanguagePathologist: {
      regex: '^SP.\\d+$',
      error: 'Begin with SP. and no space (Ex: SP.99999999)',
      errorArray: ['Must Begin with "SP."', 'No spaces', 'SP.99999999'],
    },
    hearingAidSpecialistFitter: {
      regex: '^IL.\\d+$',
      error: 'Begin with IL. and no space (Ex: IL.99999999)',
      errorArray: ['Must Begin with "IL."', 'No spaces', 'IL.99999999'],
    },

    licensedSocialWorker: {
      regex: '^M.\\d+$',
      error: 'Begin with M. and no space (Ex: M.123456)',
      errorArray: ['Must Begin with "M."', 'No spaces', 'M.123456'],
    },
    marriageAndFamilyTherapist: {
      regex: '^M.\\d+$',
      error: 'Begin with M. and no space (Ex: M.123456)',
      errorArray: ['Must Begin with "M."', 'No spaces', 'M.123456'],
    },
    licensedProfessionalCounselor: {
      regex: '^C.\\d+$',
      error: 'Begin with C. and no space (Ex: C.123456)',
      errorArray: ['Must Begin with "C."', 'No spaces', 'C.123456'],
    },
    licensedProfessionalClinicalCounselor: {
      regex: '^E.\\d+$',
      error: 'Begin with E. and no space (Ex: E.99999999)',
      errorArray: ['Must Begin with "E."', 'No spaces', 'E.99999999'],
    },
    independentMarriageAndFamilyTherapist: {
      regex: '^F.\\d+$',
      error: 'Begin with F. and no space (Ex: F.99999999)',
      errorArray: ['Must Begin with "F."', 'No spaces', 'F.99999999'],
    },
    registeredSocialWorkAssistant: {
      regex: '^W.\\d+$',
      error: 'Begin with W. and no space (Ex: W.99999999)',
      errorArray: ['Must Begin with "W."', 'No spaces', 'W.99999999'],
    },
    hairDesigner: {
      regex: '^HD.\\d+$',
      error: 'Begin with HD. and no space (Ex: HD.123456)',
      errorArray: ['Must Begin with "HD."', 'No spaces', 'HD.123456'],
    },
    hairDesignerInstructor: {
      regex: '^HDI.\\d+$',
      error: 'Begin with HDI. and no space (Ex: HDI.123456)',
      errorArray: ['Must Begin with "HDI."', 'No spaces', 'HDI.123456'],
    },
    naturalHairStylist: {
      regex: '^NHS.\\d+$',
      error: 'Begin with NHS. and no space (Ex: NHS.123456)',
      errorArray: ['Must Begin with "NHS."', 'No spaces', 'NHS.123456'],
    },
    naturalHairStylistInstructor: {
      regex: '^NHSI.\\d+$',
      error: 'Begin with NHSI. and no space (Ex: NHSI.123456)',
      errorArray: ['Must Begin with "NHSI."', 'No spaces', 'NHSI.123456'],
    },
  },
  oklahoma: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    realEstateSalesAssociate: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    realEstateBroker: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    realEstateBrokerAssociate: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  oregon: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  pennsylvania: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  rhodeIsland: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  southCarolina: {
    advancedPracticeRegisteredNurse: {
      regex: '^APRN.\\d+$',
      error: 'Begin with APRN. and no space (Ex: APRN.123456)',
      errorArray: ['Must Begin with "APRN."', 'No spaces', 'APRN.123456'],
    },
    dentist: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    //
    dentalHygienist: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    dentalSpecialist: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    dentalTechnician: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    physicalTherapyAssistant: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    physicalTherapist: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    //
    registeredNurse: {
      regex: '^\\d+$',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '^\\d+$',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },

    massageTherapist: {
      regex: '^[0-9]*$',
      error: 'Must be all numbers and no spaces (Ex: 012345)',
      errorArray: ['Must be all numbers', 'No spaces', 'Ex: 012345'],
    },

    realEstateSalesman: {
      regex: '^[0-9]*$',
      error: 'Must be all numbers and no spaces (Ex: 012345)',
      errorArray: ['Must be all numbers', 'No spaces', 'Ex: 012345'],
    },

    realEstateBroker: {
      regex: '^[0-9]*$',
      error: 'Must be all numbers and no spaces (Ex: 012345)',
      errorArray: ['Must be all numbers', 'No spaces', 'Ex: 012345'],
    },

    realEstateBrokerInCharge: {
      regex: '^[0-9]*$',
      error: 'Must be all numbers and no spaces (Ex: 012345)',
      errorArray: ['Must be all numbers', 'No spaces', 'Ex: 012345'],
    },
  },
  southDakota: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  tennessee: {
    dentist: {
      regex: '^D\\d+$',
      error: 'Begin with D and no space (Ex: D123456)',
      errorArray: ['Must Begin with "D"', 'No spaces', 'Ex: D123456'],
    },
    dentalAssistant: {
      regex: '^[0-9]*$',
      error: 'Must be all numbers and no spaces (Ex: 012345)',
      errorArray: ['Must be all numbers', 'No spaces', 'Ex: 012345'],
    },
    detanlHygienist: {
      regex: '^D\\d+$',
      error: 'Begin with D and no space (Ex: D123456)',
      errorArray: ['Must Begin with "D"', 'No spaces', 'Ex: D123456'],
    },
    clinicalLaboratoryPersonnel: {
      regex: '^[0-9]*$',
      error: 'Must be all numbers and no spaces (Ex: 012345)',
      errorArray: ['Must be all numbers', 'No spaces', 'Ex: 012345'],
    },
  },
  texas: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  utah: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  vermont: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  virginia: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  washington: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  westVirginia: {
    advancedPracticeRegisteredNurse: {
      regex: '^APRN\\d+$',
      error: 'Begin with APRN and no space (Ex: APRN99999999)',
      errorArray: ['Must Begin with "APRN"', 'No spaces', ': APRN 99999999'],
    },
    registeredNurse: {
      regex: '^\\d+$',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'No spaces', 'Ex: 99999999'],
    },
  },
  wisconsin: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
  wyoming: {
    registeredNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
    licensedPracticalNurse: {
      regex: '',
      error: 'Begin with a number and no space (Ex: 99999999)',
      errorArray: ['Must Begin with a number', 'Ex: 99999999'],
    },
  },
};



// WEBPACK FOOTER //
// ./src/constants.js